import { css } from "@emotion/react";

export const selectStyles = ({ theme, darkBackground }) => css`
    .ginput_container_select {
        position: relative;

        &::after {
            content: "";
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translateY(-50%) translateX(50%);
            height: 1em;
            width: 1em;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' color='%23005596' style='display: inline-block; stroke: currentcolor; fill: currentcolor; width: 17px; height: 17px;' class='css-9kr1gb-Icon epd9t9k0' aria-hidden='true' viewBox='0 0 1028 1024'%3E%3Cpath d='M1025.321 512.001l-90.44-85.233-356.966 336.414v-733.064h-127.831v733.064l-356.966-336.414-90.44 85.233 511.322 481.882z'%3E%3C/path%3E%3C/svg%3E");
        }
    }

    .gravityform__field__input__select {
        appearance: none;
        width: 100%;

        option {
            color: ${theme.colors.typography.defaultLightBackground};
        }
    }
`;
